import { MessageCircle } from "lucide-react";
import { useState } from "react";
import { openWhatsApp } from "@/lib/whatsapp";

export default function WhatsAppButton({ page }) {
  const [hover, setHover] = useState(false);
  return (
    <button
      data-testid="whatsapp-floating-button"
      onClick={() => openWhatsApp({ page, source: "float" })}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      className="fixed bottom-6 right-6 z-50 flex items-center gap-3 pr-1"
      aria-label="Discuter sur WhatsApp"
    >
      <span className={`overflow-hidden whitespace-nowrap rounded-full bg-white shadow-lg text-[#0F2A6B] text-sm font-semibold transition-all duration-300 ${hover ? "max-w-[240px] px-4 py-3 opacity-100" : "max-w-0 px-0 py-3 opacity-0"}`}>
        Discutez avec nos experts
      </span>
      <span className="wa-pulse grid place-items-center w-14 h-14 rounded-full bg-[#25D366] text-white shadow-xl">
        <MessageCircle className="w-7 h-7" fill="white" />
      </span>
    </button>
  );
}
